export const STORE_PAGE_CONSTANT = {
  FORM_NAME: {
    COMPANY: "companyId",
    AREA: "sectorId",
    STORE: "storeId",

    // Modal
    COMPANY_MODAL: "companyId",
    STORE_CODE_MODAL: "storeCode",
    HUB_MODAL: "hub",
    VPN_MODAL: "vpn",
    AREA_MODAL: "sectorId",
    STORE_NAME_MODAL: "storeName",
    EMAIL_MODAL: "email",
    MOBILE_PHONE_MODAL: "phone",
  },

  TABLE_KEY: {
    KEY: "key",
    COMPANY_CODE: "companyCode",
    STORE_CODE: "storeCode",
    STORE_NAME: "storeName",
    AREA_CODE: "sectorCode",
    HUB: "hub",
    VPN: "vpn",
  },
};

export const MAX_LENGTH_STORE_CODE = 5;
export const MAX_LENGTH_50 = 50;
export const MAX_LENGTH_11 = 11;
export const LIST_KEYS_ALLOW_PHONE = [
  "Backspace",
  "Tab",
  "Shift",
  "ArrowRight",
  "ArrowLeft",
];
export const REGEX_STORE_CODE = /^[a-zA-Z0-9]{1,5}$/;
export const REGEX_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_IP_V4 =
  /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/;
